import { apiFetch } from "./http";

export type SecuritySummary = {
  isAdmin: boolean;
  totpEnrolled: boolean;
  ownerRecoveryKeyConfigured: boolean;
};

export async function fetchSecuritySummary(): Promise<SecuritySummary> {
  return apiFetch("/auth/account/security-summary");
}

export async function elevateOwnerSession(
  totpCode: string,
  purpose:
    | "owner_recovery_key_generate"
    | "owner_recovery_key_rotate"
    | "revoke_all_sessions"
    | "regenerate_login_recovery_codes",
): Promise<{ elevated: true; expiresAt: string }> {
  return apiFetch("/auth/owner/elevate", {
    method: "POST",
    body: JSON.stringify({ totpCode, purpose }),
  });
}

export async function generateOwnerRecoveryKey(): Promise<{ recoveryKey: string }> {
  return apiFetch("/auth/owner/recovery-key/generate", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export async function revokeAllSessionsSecure(): Promise<void> {
  await apiFetch("/auth/logout-all-secure", { method: "POST", body: JSON.stringify({}) });
}
